<template>
  <div class="scenic-overview" :style="{ backgroundImage: 'url(' + msgBack + ')' }">
    <div class="breadcrumb">
      <img :src="pointImg" alt="" class="breadcrumb-icon">
      <span>当前位置：<span class="breadcrumb-link" @click="$emit('go-home')">首页</span> / <span class="breadcrumb-link" @click="$emit('back')">走进花果山</span> / 景区概况</span>
    </div>
    <div class="detail-title">景区概况</div>
    <div class="detail-content" v-html="content"></div>
  </div>
</template>

<script>
import { getArticles, getArticleDetail } from '../api/index'
import pointImg from '../assets/imgs/point.png'
import msgBack from '../assets/imgs/msgBack.cc9c9f44.png'

export default {
  name: 'ScenicOverview',
  emits: ['back', 'go-home'],
  data() {
    return {
      pointImg,
      msgBack,
      content: '<p>加载中...</p>',
    }
  },
  mounted() {
    this.fetchOverview()
  },
  methods: {
    async fetchOverview() {
      try {
        const listRes = await getArticles({ category: 'overview', lang: 'zh', pageSize: 1 })
        const items = listRes.rows || listRes.data || []
        if (!items.length) {
          this.content = '<p>暂无内容</p>'
          return
        }
        const detailRes = await getArticleDetail(items[0].id)
        if (detailRes.code === 200 && detailRes.data) {
          this.content = detailRes.data.content || '<p>暂无内容</p>'
        }
      } catch (e) {
        this.content = '<p>暂无内容</p>'
      }
    },
  },
}
</script>

<style scoped lang="less">
.scenic-overview{
  padding: 0.3rem;
  padding-bottom: 0.4rem;
  background-size: 100% 100%;
  background-position: center;
  .breadcrumb{
    padding-top: 0.1rem;
    padding-left: 0.1rem;
    padding-right: 0.1rem;
    font-size: 0.24rem;
    color: #666;
    display: flex;
    align-items: center;
    margin-bottom: 0.3rem;
    .breadcrumb-icon{
      width: 0.2rem;
      margin-right: 0.1rem;
    }
    .breadcrumb-link{
      cursor: pointer;
      &:hover{
        color: #369BF8;
      }
    }
  }
  .detail-title{
    font-size: 0.32rem;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin-bottom: 0.15rem;
  }
  .detail-date{
    font-size: 0.18rem;
    color: #999;
    text-align: center;
    margin-bottom: 0.3rem;
  }
  .detail-content{
    font-size: 0.2rem;
    color: #4F4E4E;
    line-height: 0.5rem;
    p{
      text-indent: 2em;
      margin-bottom: 0.15rem;
    }
    img{
      max-width: 100%;
    }
  }
}
</style>
